<div class="grid">
  <div class="col-12 md-col-4 md-offset-col-4">
    @for(signature of signatures; track $index){
      <p-panel [collapsed]="true" [toggleable]="true" toggler="header" expandIcon="pi pi-chevron-up" collapseIcon="pi pi-chevron-down" styleClass="mb-3">
        <ng-template pTemplate="header">
          <div class="flex-column align-items-start gap-2">
            <div class="flex align-items-center gap-2 cursor-pointer">
              <ng-container *ngIf="!signature.signed">
                <i class="pi pi-circle"></i>
              </ng-container>
              <ng-container *ngIf="signature.signed">
                <i class="pi pi-check-circle text-green-700"></i>
              </ng-container>
              <span class="font-bold text-xl text-color">{{signature.uiName}}</span>
            </div>
            <p class="font-normal">{{signature.uiDescription }}</p>
          </div>
        </ng-template>
        <div class="m-0">
          <ng-container *ngIf="signature.uiSignatureType == SignType.digital">
            <div class="pt-2 pb-3">
              <a href="{{signature.uiHyperlink}}" target="_blank" class="text-lg no-underline text-primary">
                Weitere Informationen
                <i class="pi pi-arrow-up-right"></i>
              </a>
            </div>
            <div class="flex flex-wrap align-items-center justify-content-between gap-3">
              <span class="font-semibold text-medium">Bestätigung</span>
              <p-inputSwitch [(ngModel)]="signature.signatureSwitch" (onChange)="onSignatureChange(signature)"  [readonly]="signature.signed && !signatureRemovable" class="mr-4"></p-inputSwitch>
            </div>
          </ng-container>
          <ng-container *ngIf="signature.uiSignatureType == SignType.handWritten">
            <div class="pt-2 pb-3">
              <a href="{{signature.uiHyperlink}}" target="_blank" class="text-lg no-underline text-primary">
                Was wird unterschrieben?
                <i class="pi pi-arrow-up-right"></i>
              </a>
            </div>
            <div class="flex flex-wrap align-items-center justify-content-center pt-2 pb-1">
              <div *ngIf="signatureRemovable" (click)="openSignatureModal(signature)" class="show-in-landscape flex justify-content-center align-items-center border-1 border-round-3xl border-primary" style="width:300px;height:100px;">

                @if (!signature.signed){
                  <span>Hier gehts zur Unterschrift</span>
                } @else {
                  <img style="width:300px;height:100px;" [src]="'data:'+signature.signatureMimeType+';Base64,'+signature.signatureBase64" alt="">
                }
              </div>
              <div class="show-in-portrait flex flex-column">
                <div class="flex justify-content-center mb-3"><i class="pi pi-mobile text-3xl"></i><i class="pi pi-refresh text-3xl"></i></div>
                <span>Mobiltelefon auf die Seite drehen...</span>
              </div>
            </div>
            <p-dialog class="signature-pad-dialog" header="Deine Unterschrift"  styleClass="p-0 m-0" [(visible)]="signatureModalVisible" [modal]="true">
              <rg-signature-pad></rg-signature-pad>
              <ng-template pTemplate="footer">
                <span class="flex justify-content-between">
                  <p-button icon="pi pi-replay" [outlined]="true" severity="secondary" (click)="clearSignaturePad(signature)" label="Zurücksetzten" pAutoFocus [autofocus]="true" ></p-button>
<!--                  <p-button icon="pi pi-verified" styleClass="mr-0" [outlined]="true" (click)="saveSignature(signature)" label="Unterschreiben"></p-button>-->
                  <!-- Disabled Button when signature pad is empty (1000001248)-->
                  <app-button [busy]="busy"
                              [outlined]="true"
                              [class]="'mr-0'"
                              [label]="'Unterschreiben'"
                              [icon]="'pi pi-verified'"
                              [disabled]="signaturePad?.isEmpty()"
                              (onClick)="saveSignature(signature)">
                  </app-button>

                </span>
              </ng-template>
            </p-dialog>
          </ng-container>
          <div class="flex justify-content-center pt-3">
            <span class="p-text-secondary">{{signature.signatureTimeStamp | date:'dd.MM.yyyy HH:mm:ss'}}</span>
          </div>
        </div>
      </p-panel>
    }
  </div>
</div>



